import NavItemOption from "interfaces/NavItemOption";
import { useState } from "react";
import { useHistory } from "react-router";
import SubNavMenuePopover from "./SubNavMenuePopover";

export default function NavItem(props: NavItemOption) {
  const history = useHistory();
  const { isActive, itemId: navItemId, text, route, children } = props;

  const [isSubmenuVisible, setIsSubmenuVisible] = useState(false);

  const handleNavItemClick = () => {
    if (children?.length) {
      setIsSubmenuVisible((prevState) => !prevState);
    } else if (route) {
      history.push(route);
    }
  };

  const closeSubmenu = () => {
    setIsSubmenuVisible(false);
  };

  const getActiveStateClass = () => {
    return isActive ? "text-black border-b-2 active-nav" : "";
  };

  const getNavItemId = () => {
    return `nav-item-id-${navItemId}`;
  };

  return (
    <div className="inline-block">
      <div
        id={getNavItemId()}
        className={`nav-item relative text-center border-black text-bold text-2xl cursor-pointer leading-7 hover:text-black ${
          isSubmenuVisible ? "text-black" : ""
        } ${getActiveStateClass()} ${
          !isActive && !isSubmenuVisible ? "text-promGray" : ""
        }`}
        onClick={handleNavItemClick}
        data-text={text}
      >
        <div className="nav-item-text">{text}</div>
      </div>
      {isSubmenuVisible && (
        <SubNavMenuePopover
          target={`#${getNavItemId()}`}
          menuItems={children || []}
          onClose={closeSubmenu}
          onSelect={closeSubmenu}
          yOffset={20}
        />
      )}
    </div>
  );
}
